var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_6246)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "#E84142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 184C172.333 184 218 138.333 218 82C218 25.6669 172.333 -20 116 -20C59.667 -20 14 25.6669 14 82C14 138.333 59.667 184 116 184Z",
    fill: "#E84142"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1003_6246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1003_6246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 136,
    height: 136
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.951 25H25.041V161H160.951V25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1003_6246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.908 48.3298H50.9932V124.649H134.908V48.3298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.905 93C160.905 130.506 130.502 160.91 92.9961 160.91C55.4906 160.91 25.0864 130.506 25.0864 93C25.0864 55.4946 55.4906 25.0905 92.9961 25.0905C130.502 25.0905 160.905 55.4946 160.905 93ZM73.7523 120.025H60.5731C57.8037 120.025 56.4357 120.025 55.6016 119.491C54.7006 118.907 54.1503 117.939 54.0833 116.871C54.0334 115.888 54.7174 114.686 56.0853 112.284L88.6268 54.9251C90.0115 52.4893 90.7122 51.2715 91.5962 50.821C92.5472 50.3373 93.6816 50.3373 94.6326 50.821C95.5168 51.2715 96.2176 52.4893 97.602 54.9251L104.292 66.603L104.326 66.6625C105.822 69.2755 106.58 70.6007 106.911 71.9915C107.278 73.5095 107.278 75.111 106.911 76.6293C106.577 78.0305 105.827 79.3652 104.308 82.0178L87.2153 112.234L87.1712 112.311C85.6659 114.946 84.9027 116.281 83.8455 117.288C82.6943 118.39 81.3096 119.19 79.7916 119.641C78.4069 120.025 76.8554 120.025 73.7523 120.025ZM107.035 120.025H125.919C128.705 120.025 130.107 120.025 130.941 119.475C131.842 118.891 132.409 117.906 132.459 116.839C132.508 115.887 131.838 114.732 130.527 112.469C130.482 112.392 130.437 112.314 130.39 112.234L120.931 96.0518L120.823 95.8696C119.494 93.6219 118.823 92.4868 117.962 92.048C117.011 91.5641 115.893 91.5641 114.942 92.048C114.075 92.4985 113.374 93.683 111.989 96.0685L102.564 112.251L102.531 112.306C101.152 114.688 100.462 115.879 100.512 116.855C100.578 117.923 101.129 118.907 102.03 119.491C102.847 120.025 104.248 120.025 107.035 120.025Z",
    fill: "#E84142"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_6246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1003_6246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.17bd5d0819d97e68cb6fe67512981ade.svg";
export { ForwardRef as ReactComponent };